import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 1000px;
  margin: 0 auto 100px;
  text-align: center;
  padding: 100px 0;
  border-top: 1px solid var(--text-dark);

  @media (max-width: 768px) {
    margin: 0 auto 50px;
    padding: 80px 0;
  }

  .overline {
    display: block;
    margin-bottom: 30px;
    color: var(--accent-main);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.2em;
  }

  .title {
    font-size: clamp(60px, 10vw, 120px);
    font-weight: 800;
    line-height: 1;
    margin-bottom: 30px;
    letter-spacing: -0.04em;
    color: var(--text-main);
    text-transform: uppercase;
  }

  p {
    max-width: 600px;
    margin: 0 auto 50px;
    font-size: var(--fz-xl);
    color: var(--text-muted);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    font-size: var(--fz-xl);
    padding: 1.5rem 3rem;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <span className="overline">What's Next?</span>

      <h2 className="title">Let's Talk.</h2>

      <p>
        Currently exploring new opportunities and open to exciting projects.
        Whether you have a question, a proposal, or just want to say hi, my inbox is always open.
      </p>

      <a className="email-link" href={`mailto:${email}`}>
        Say Hello
      </a>
    </StyledContactSection>
  );
};

export default Contact;
